module.exports = __webpack_public_path__ + "static/media/testing_05@3x.821829e4.png";